import React from "react";

import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import FadeIn from "react-fade-in";
import Button from "react-bootstrap/Button";

import { IoMdShare } from "react-icons/io";

import { withQueryParams } from "../../common/queryParams";
import { getPageLink } from "../../common/appLinkBuilder";

class ConclusionPage extends React.Component {
  state = {};
  render() {
    const {
      page,
      name,
      data: { tennisPersonality, properties },
      fadeTimeout,
    } = this.props;
    const { playerId, shared } = this.props.queryParams;

    const shareData = {
      title: `${name}: 2022 tennis year in numbers`,
      text: `Check out ${shared ? `${name}'s` : "my"} 2022 tennis year in numbers`,
      url: getPageLink("wrapped", "", { embed: "true", playerId: playerId, shared: "true" }),
    };

    return (
      <Container className="mt-5">
        <Row>
          <Col>
            <h1>{shared ? `${name}'s ` : "Your"} Tennis Personality</h1>
          </Col>
        </Row>
        <FadeIn delay={fadeTimeout} key={page}>
          <Row className="mt-3">
            <Col>
              <div className="mt-3">&nbsp;</div>
              <div className="mt-3">&nbsp;</div>
              <h1 className="text-primary fw-bold ms-n3" style={{ fontSize: "45px" }}>
                {tennisPersonality}
              </h1>
              <div className="mt-3">&nbsp;</div>
            </Col>
          </Row>
          {properties.map((p) => (
            <Row className="mt-3" key={p}>
              <Col>
                <h1 className="text-secondary">{p}</h1>
              </Col>
            </Row>
          ))}
          <Row className="mt-3 fs-4">
            <Col>
              <div className="mt-3">&nbsp;</div>
              <div className="mt-3">&nbsp;</div>
              {!shared && (
                <Button onClick={async () => await navigator.share(shareData)}>
                  <IoMdShare size="25" /> Share This Story
                </Button>
              )}
              {shared && (
                <React.Fragment>
                  <div className="fs-4">Liked {name}'s story for 2022?</div>
                  <Button className="mt-2" size="lg" variant="primary" href="https://go.ats.tennis/story-for-2023" target="_blank">
                    Get your own for 2023
                  </Button>
                </React.Fragment>
              )}
            </Col>
          </Row>
        </FadeIn>
      </Container>
    );
  }
}

export default withQueryParams(ConclusionPage);
